import project1 from "../components/images/project1.png";
import project2 from "../components/images/project2.png";
import project3 from "../components/images/project3.png";
import project4 from "../components/images/project4.png";

export const projectsUtils = [
  {
    id: 1,
    batch: "Full stack",
    color:"primary",
    title: "shopey ecommerce website",
    image: project1,
    link: "https://arjun-shopey.netlify.app/",
    description:
      "Shopey is a dynamic and responsive ecommerce application developed using the MERN (MongoDB, Express, React, Node.js) stack, designed to provide an efficient and enjoyable online shopping experience",
  },
  {
    id: 2,
    batch: "Full stack",
    color:"secondary",
    title: "Recipe app",
    image: project2,
    link: "https://arjunchauahan-recipe-app.netlify.app/",
    description:
      "Proud to introduce my MERN-based Recipe App, a coding passion project that brings culinary delight to your fingertips. Secure user authentication, stunning recipe cards, detailed instructions, and a powerful search feature – all in one app. Create, edit, and delete your recipes while enjoying others culinary creations. Discover the joy of cooking today!",
  },
  {
    id: 3,
    batch: "Full stack",
    color:"success",
    title: "My portfolio",
    image: project3,
    link: "https://arjunchauhan007.netlify.app/",
    description:
      "Introducing my previous portfolio project, as an integral part of my current venture. This project represents my journey and experience in web developement, showcasing my growth and expertise. Stay tuned for a deeper dive into my evolving portfolio!",
  },
  {
    id: 4,
    batch: "Javascript",
    color:"danger",
    title: "Titan watch",
    image: project4,
    link: "https://arjun-kn.github.io/Javascript-project/",
    description:
      "Welcome to the Titan Watch Collection – where elegance meets precision. Explore our exquisite range of timepieces that blend classic design with cutting-edge technology. Discover the perfect watch to complement your style, whether its for a formal occasion, everyday wear, or a special gift.",
  },
  {
    id: 5,
    batch: "Node js",
    color:"warning",
    title: "Resturant Management",
    image: "https://codecanyon.img.customer.envatousercontent.com/files/459073213/2+%281%29.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=3b0c507ec0617fb42ddc7f74bed75bac",
    link: "https://github.com/Arjun-kn/Resturant-Backend",
    description:
      "The Restaurant Management System is a comprehensive web application designed to streamline the operations of a restaurant. Built with Node.js, Express.js, and MongoDB, this system offers an intuitive interface for managing various aspects of a restaurant, including menu items, orders, reservations, and staff.",
  },
];
